<script>
import {VueFinalModal} from 'vue-final-modal';

import {useVuelidate} from '@vuelidate/core'
import {helpers, required} from '@vuelidate/validators'
import dropZone2Component from "@/components/subcomponents/dropZone2Component.vue";

import fileDownload from 'js-file-download';

require('purecss/build/tables-min.css');

export default {
  inject: ['$axios', '$_', '$apiBaseURL', '$appVer', '$DateTime'],
  emits: ["cancel", "save"],
  props: {
    title: String,
    formFor: String,
    currentTableData: Array,
    currentTableConfig: Object,
    currentDisplayedDataVisibility: Object,
    tableRef: String,
    invoiceTableData: Object,
    surgeryTableData: Object,
    userIdentificationData: Object,
    fundsUpdatingData: Object,
    partnerSelectData: Object
  },
  name: "vueFinalModal",
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      exportData: {
        tableProps: true,
        scopeDetails: true,
        dataScope: '',
        fileType: 'fileTypeCsv',
        exportScope: 'visibleRecords'
      },
      activePartners: [],
      partnerSelectType: 'radio',
      userProfileData: {
        role: '',
        partner: {}
      },
      invoice: {number: '', date: '', amount: '', currency: '', file: '', dropzone2Trigger: ''},
      signedInvoice: {file: '', dropzone2Trigger: ''},
      remittanceAdvice: {ref: '', date: '', amount: '', currency: '', file: '', dropzone2Trigger: ''},
      receipt: {number: '', date: '', amount: '', currency: '', file: '', usdrate: '', dropzone2Trigger: ''},
      partnerDetails: {name: '', shortname: '', location: '', email: '', description: ''},
      fund: {limit: ''},
      imports: {file: ''},
      invoiceFileUploaded: false,
      signedInvoiceFileUploaded: false,
      remittanceFileUploaded: false,
      receiptFileUploaded: false,
      importsFileUploaded: false,
      fundLimitSaved: false,
      locationsAvailable: [],
      surgeriesReturned: [],
      surgeryChange: {
        surgeryPerformed: '',
        safeAskAmount: '-',
      }
    }
  },
  validations() {
    let vm = this;
    let validationObj = {};
    switch (vm.formFor) {
      case 'tableExports':
        validationObj = {
          exportData: {
            fileType: {required: helpers.withMessage("Please select the file type", required)},
            exportScope: {required: helpers.withMessage("Please select the scope of the data", required)}
          }
        };
        break;
      case 'attachingPartnerInvoice':
        validationObj = {
          invoice: {
            number: {required: helpers.withMessage("Please insert Invoice Number", required)},
            date: {required: helpers.withMessage("Please insert Invoice Date", required)},
            amount: {required: helpers.withMessage("Please insert Invoice Amount", required)},
            currency: {required: helpers.withMessage("Please insert Invoice Currency", required)},
          }
        };
        break;
      case 'safePartnerForm':
        validationObj = {
          partnerDetails: {
            name: {required: helpers.withMessage("Please insert Partner Name", required)},
            shortname: {required: helpers.withMessage("Please insert Partner Shortname", required)},
            location: {required: helpers.withMessage("Please insert Partner Location", required)},
            email: {required: helpers.withMessage("Please insert Partner Email", required)}
          }
        };
        break;
      case 'attachingAmhInvoice':
        validationObj = {
          signedInvoice: {
            file: {required: helpers.withMessage("Please attach the signed Invoice", required)},
          }
        };
        break;
      case 'attachingRemittance':
        validationObj = {
          remittanceAdvice: {
            ref: {required: helpers.withMessage("Please provide the remittance reference", required)},
            date: {required: helpers.withMessage("Please provide the remittance date", required)},
            amount: {required: helpers.withMessage("Please provide the remittance amount", required)},
            currency: {required: helpers.withMessage("Please select the remittance currency", required)},
            file: {required: helpers.withMessage("Please attach the remittance advice", required)},
          }
        };
        break;
      case 'attachingReceipt':
        validationObj = {
          receipt: {
            number: {required: helpers.withMessage("Please provide the receipt number", required)},
            date: {required: helpers.withMessage("Please provide the receipt date", required)},
            amount: {required: helpers.withMessage("Please provide the receipt amount", required)},
            currency: {required: helpers.withMessage("Please select the receipt currency", required)},
            file: {required: helpers.withMessage("Please attach the receipt document", required)},
            usdrate: {required: helpers.withMessage("Please provide the current USD exchange rate", required)},
          }
        };
        break;
      case 'updatingFundsAllocation':
        validationObj = {
          fund: {
            limit: {required: helpers.withMessage("Please provide the new fund limit", required)},
          }
        };
        break;
      case 'changingSurgeryPerformed':
        validationObj = {
          surgeryChange: {
            surgeryPerformed: {required: helpers.withMessage("Please select the surgery performed", required)}
          }
        };
        break;
    }
    return validationObj;
  },
  components: {
    VueFinalModal,
    dropZone2Component
  },
  computed: {
    setDatePickerClassInvoiceDate: function () {
      let vm = this;
      try {
        if (vm.v$.invoice.date.$errors.length > 0) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    setDatePickerClassRemitanceDate: function () {
      let vm = this;
      try {
        if (vm.v$.remittanceAdvice.date.$errors.length > 0) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    setDatePickerClassReceiptDate: function () {
      let vm = this;
      try {
        if (vm.v$.receipt.date.$errors.length > 0) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    invoiceDateConstrain: function () {
      let vm = this;
      if (typeof vm.currentData.country_tz !== 'undefined') {
        return {
          from: vm.$DateTime.local().setZone(vm.currentData.country_tz).toJSDate()
        }
      } else {
        return {
          from: vm.$DateTime.local().toJSDate()
        };
      }
    },
    invoiceSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0);
    },
    signedInvoiceSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0 || !vm.signedInvoiceFileUploaded);
    },
    remittanceSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0 || !vm.remittanceFileUploaded);
    },
    receiptSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0 || !vm.receiptFileUploaded);
    },
    saveUserProfileActive: function () {
      let vm = this;
      // console.log(vm.$_.isEmpty(vm.userProfileData.partner));
      return !((vm.userProfileData.role === '' || vm.userProfileData.role === null) || vm.$_.isEmpty(vm.userProfileData.partner));
    },
    saveSafePartnerActive: function () {
      let vm = this;
      // vm.validateForm();
      console.log(vm.v$);
      return !(vm.v$.$errors.length > 0);
    },
    fundLimitSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0);
    },
    surgeryChangeSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0);
    }
  },
  methods: {
    uploadInProgress: function (uploadInProgressEmission) {
      let vm = this;
      switch (vm.formFor) {
        case 'tableExports':
          break;
        case 'attachingPartnerInvoice':
          vm.invoiceFileUploaded = uploadInProgressEmission.uploadDone;
          break;
        case 'attachingAmhInvoice':
          vm.signedInvoiceFileUploaded = uploadInProgressEmission.uploadDone;
          break;
        case 'amhRemittanceAtachment':
          vm.remittanceFileUploaded = uploadInProgressEmission.uploadDone;
          break;
      }
    },
    dropZone2Emissions: function (dropZone2Emission) {
      let vm = this;
      console.log(vm.formFor);
      console.log(dropZone2Emission);
      switch (vm.formFor) {
        case 'tableExports':
          break;
        case 'attachingPartnerInvoice':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.invoice.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.invoice.file = '';
          }
          vm.invoiceFileUploaded = true;
          break;
        case 'attachingAmhInvoice':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.signedInvoice.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.signedInvoice.file = '';
          }
          vm.signedInvoiceFileUploaded = true;
          break;
        case 'attachingRemittance':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.remittanceAdvice.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.remittanceAdvice.file = '';
          }
          vm.remittanceFileUploaded = true;
          break;
        case 'attachingReceipt':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.receipt.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.receipt.file = '';
          }
          vm.receiptFileUploaded = true;
          break;
        case 'tableImports':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.imports.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.imports.file = '';
          }
          vm.importsFileUploaded = true;
          break;
      }

    },
    invoiceDateSelected: function () {
    },
    remittanceDateSelected: function () {
    },
    decimalNumbersAllowed: function (event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127 || charCode === 190) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    closeModal: function () {
      let vm = this;
      vm.$emit('cancel', {});
    },
    processExport: function () {
      let vm = this;
      vm.validateForm();
      let reportsTables = [
        'invoiceStageReports', 'openStageReports', 'awaitingPartnerInvoiceFinancials',
        'attachedPartnerInvoiceFinancials', 'invoicedPreviewForAmhInvoice', 'sentAmhInvoiceFinancials',
        'awaitingAmhRemittanceFinancials', 'awaitingPartnerReceiptFinancials', 'receivedPartnerReceiptFinancials',
        'completedFinancials', 'activeDataCases'];
      let adminTables = ['partnersAdmin', 'usersAdmin', 'preapprovalsAdmin', 'watsiFunds', 'amhcontingencyFunds',
        'amhecsFunds', 'amhsvdFunds', 'amhotherFunds'];

      let exportsEndpoint = '';
      if (vm.$_.includes(reportsTables, vm.tableRef)) {
        exportsEndpoint = `/report/action/fetchforExport`;
      }
      if (vm.$_.includes(adminTables, vm.tableRef)) {
        exportsEndpoint = `/admin/action/fetchforExport`;
      }


      console.log(vm.exportData);
      console.log(vm.formFor);
      console.log(vm.currentTableData);
      console.log(vm.currentTableConfig);
      console.log(vm.tableRef);
      console.log(vm.currentDisplayedDataVisibility);
      console.log(exportsEndpoint);

      vm.$axios
          .post(exportsEndpoint, {
            repData: vm.currentData,
            exportData: vm.exportData,
            currentTableData: vm.currentTableData,
            currentTableConfig: vm.currentTableConfig,
            tableRef: vm.tableRef,
            currentDisplayedDataVisibility: vm.currentDisplayedDataVisibility,
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            },
            responseType: 'blob'
          })
          .then(function (response) {
            console.log(response);
            console.log(response.data);
            let fileTime = vm.$DateTime.local().setZone("UTC").toFormat('yyyy_LL_dd_hhmmss'),
                filename = `${vm.tableRef}_${fileTime}.csv`;
            fileDownload(response.data, filename);
          })
    },
    savePartnerInvoiceData: function () {
      let vm = this;
      try {
        if (vm.invoiceSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertPartnerInvoice', {
                  repData: vm.currentData,
                  invoiceData: vm.invoice,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveSignedAmhInvoiceData: function () {
      let vm = this;
      try {
        if (vm.signedInvoiceSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertSignedAmhInvoice', {
                  repData: vm.currentData,
                  signedInvoice: vm.signedInvoice,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveAmhRemittanceData: function () {
      let vm = this;
      try {
        if (vm.remittanceSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertRemittanceAdvice', {
                  repData: vm.currentData,
                  remittanceAdvice: vm.remittanceAdvice,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveReceiptData: function () {
      let vm = this;
      try {
        if (vm.receiptSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertReceiptData', {
                  repData: vm.currentData,
                  receipt: vm.receipt,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveUserProfile: function () {
      let vm = this;
      try {
        if (vm.saveUserProfileActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.saveUserProfileActive = false;
            vm.$axios
                .post('/admin/action/updateUserProfile', {
                  coordData: vm.currentData,
                  userProfileData: vm.userProfileData,
                  formFor: vm.formFor,
                  userIdentificationData: vm.userIdentificationData
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveSafePartner: function () {
      let vm = this;
      try {
        vm.validateForm();
        if (vm.v$.$errors.length === 0) {
          vm.saveSafePartnerActive = false;
          vm.$axios
              .post('/admin/action/updateSafePartner', {
                coordData: vm.currentData,
                partnerDetails: vm.partnerDetails,
                formFor: vm.formFor,
                partnerid: (typeof vm.partnerSelectData !== 'undefined' && typeof vm.partnerSelectData.partnerid !== 'undefined') ? vm.partnerSelectData.partnerid : 'new'
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${vm.currentData.token}`
                }
              })
              .then(function (response) {
                switch (response.data.success) {
                  case 'true':
                    vm.$emit('save', {});
                    break;
                }
              });
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveNewLimitData: function () {
      let vm = this;
      try {
        if (vm.fundLimitSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/admin/action/updateLimitData', {
                  coordData: vm.currentData,
                  fund: vm.fund,
                  formFor: vm.formFor,
                  fundsUpdatingData: vm.fundsUpdatingData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveNewSurgeryPerformed: function () {
      let vm = this;
      try {
        if (vm.fundLimitSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/profile/action/changeSurgeryPerformed', {
                  coordData: vm.currentData,
                  surgeryChange: vm.surgeryChange,
                  surgeryTableData: vm.surgeryTableData
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  switch (response.data.success) {
                    case 'true':
                      vm.$emit('save', {});
                      break;
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    toggleExportPrefs: function (checkName) {
      let vm = this;
      switch (checkName) {
        case 'tableProps':
          vm.exportData.tableProps = !vm.exportData.tableProps;
          break
        case 'scopeDetails':
          vm.exportData.scopeDetails = !vm.exportData.scopeDetails;
          break
      }
    },
    toggleFileType: function (fileType) {
      let vm = this;
      switch (fileType) {
        case 'pdf':
          vm.exportData.fileType = 'fileTypePdf';
          break
        case 'csv':
          vm.exportData.fileType = 'fileTypeCsv';
          break
      }
    },
    toggleScopeType: function (scopeName) {
      let vm = this;
      vm.exportData.exportScope = scopeName
    },
    selectUserRole: function (roleName) {
      let vm = this;
      vm.userProfileData.role = roleName
    },
    selectPartnerPermitted: function (partnerId) {
      let vm = this;
      if (typeof vm.userProfileData.partner[partnerId] === 'undefined') {
        if (vm.partnerSelectType === 'radio') {
          vm.userProfileData.partner = {};
          vm.userProfileData.partner[partnerId] = 'selected';
        } else {
          vm.userProfileData.partner[partnerId] = true;
        }
      } else {
        if (vm.partnerSelectType === 'checkbox') {
          vm.userProfileData.partner[partnerId] = !vm.userProfileData.partner[partnerId];
        }
        if (vm.partnerSelectType === 'radio') {
          vm.userProfileData.partner = {};
          vm.userProfileData.partner[partnerId] = 'selected';
        }
      }

    },
    returnDataTsAndPartnerId: function (caseId, recordyear) {
      let vm = this;
      return `${caseId}_${vm.currentData.partnerid}_${recordyear}`
    },
    returnDataInvoiceAndPartnerId: function (invoiceNumber, recordyear) {
      let vm = this;
      let cleanedInvoiceNumber = invoiceNumber.replace(/ /g, "__");
      cleanedInvoiceNumber = cleanedInvoiceNumber.replace(/\//g, "_");

      return `${cleanedInvoiceNumber}__${vm.invoiceTableData.partnerid}_${recordyear}`
    },
    returnArrayFromCSV: function (csvText) {
      let vm = this;
      return vm.$_.split(csvText, ',');
    },
    async validateForm() {
      const vm = this;
      await this.v$.$validate();
      vm.validationHasOccured = true;
    },
    resizeById(textAreaId) {
      let element = document.getElementById(textAreaId);
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    }
  },
  async mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);

    if (vm.formFor === 'manageUserProfile') {
      console.log('get active partners');
      vm.$axios
          .post('/admin/action/userManagementFetch', {
            userid: vm.userIdentificationData.userid,
            userEmail: vm.userIdentificationData.userEmail,
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            console.log(response.data);

            vm.userProfileData.role = response.data.userData.role !== null ? response.data.userData.role : '';
            vm.activePartners = response.data.partnerData;

            if (response.data.userData.partner !== null) {
              let selectedPartners = vm.$_.split(response.data.userData.partner, ',');

              vm.userProfileData.partner = {};
              if (vm.userProfileData.role === '' || vm.userProfileData.role === 'Representative') {
                vm.partnerSelectType = 'radio';
                if (selectedPartners.length > 0) {
                  vm.userProfileData.partner[selectedPartners[0]] = 'selected';
                }
              } else {
                vm.partnerSelectType = 'checkbox';
                if (selectedPartners.length > 0) {
                  vm.$_.forEach(selectedPartners, function (partnerId) {
                    vm.userProfileData.partner[partnerId] = true;
                  })
                }
              }
            }

          });
    }

    if (vm.formFor === 'safePartnerForm') {
      console.log('get countries');
      vm.$axios
          .post('/admin/action/appCountriesFetch', {}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            console.log(response.data);
            vm.locationsAvailable = response.data.countries;
          });

      if (typeof vm.partnerSelectData !== 'undefined' && typeof vm.partnerSelectData.partnerid !== 'undefined') {
        console.log(`fetch partner ${vm.partnerSelectData.partnerid}`);
        vm.$axios
            .post('/admin/action/partnerFetch', {partnerid: vm.partnerSelectData.partnerid}, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              console.log(response.data);
              if (response.data.success === 'true') {
                vm.partnerDetails = {
                  name: response.data.partner_name,
                  shortname: response.data.partner_shortname,
                  location: response.data.partner_location,
                  email: response.data.partner_email,
                  description: response.data.partner_description
                };
              }
            });
      }
    }


    if (vm.formFor === 'changingSurgeryPerformed') {
      try {
        vm.$axios
            .post('/profile/action/fetchPartnerSurgeries', {
              profileID: `id-${vm.surgeryTableData.caseid}`,
              partnerid: vm.surgeryTableData.partnerid
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              // console.log(response.data);
              vm.surgeriesReturned = response.data.surgeriesArr;
            });
      } catch (error) {
        console.error(error);
        vm.surgeriesReturned = [];
      }
    }


  },
  watch: {
    userProfileData: {
      handler() {
        let vm = this;
        console.log(vm.userProfileData);
        console.log(vm.partnerSelectType);
        if (vm.userProfileData.role === 'Representative' && vm.partnerSelectType !== 'radio') {
          vm.userProfileData.partner = {};
          vm.partnerSelectType = 'radio';
        }

        if (vm.userProfileData.role === 'Coordinator' && vm.partnerSelectType !== 'checkbox') {
          vm.userProfileData.partner = {};
          vm.partnerSelectType = 'checkbox';
        }

        if (!vm.$_.isEmpty(vm.userProfileData.partner)) {
          let partnerSelection = vm.$_.pickBy(vm.userProfileData.partner, vm.$_.identity);
          console.log(partnerSelection);
          if (!vm.$_.isEqual(partnerSelection, vm.userProfileData.partner))
            vm.userProfileData.partner = partnerSelection;
        }
      },
      deep: true
    },
    surgeryChange: {
      async handler(newValue) {
        let vm = this;
        if (newValue.surgeryPerformed !== '') {
          vm.$_.forEach(vm.surgeriesReturned, function (surgeryData) {
            if (vm.$_.trim(surgeryData.surgery).toLowerCase() === vm.$_.trim(newValue.surgeryPerformed).toLowerCase()) {
              vm.surgeryChange.safeAskAmount = `${surgeryData.currency} ${surgeryData.cost}`;
            }
          });
        }
      },
      deep: true
    }
  }
};
</script>

<template>
  <VueFinalModal
      class="confirm-modal"
      content-class="confirm-modal-content"
      overlay-transition="vfm-fade"
      content-transition="vfm-fade"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete button is-black" aria-label="close" v-on:click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <slot></slot>
        <div v-if="formFor==='tableExports'">
          <div class="columns is-centered is-multiline is-vcentered margin-0">
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="checkbox" id="exportallrecords"
                           value="exportallrecords"
                           class="fancy-input"
                           v-model="exportData.tableProps"
                           v-on:click.prevent/>
                    <label for="exportallrecords" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleExportPrefs('tableProps')">Use Table Props</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="checkbox" id="exportdetails"
                           value="exportdetails"
                           class="fancy-input"
                           v-model="exportData.scopeDetails"
                           v-on:click.prevent/>
                    <label for="exportdetails" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleExportPrefs('scopeDetails')">with Details</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <slot name="fileScope"></slot>
          <div class="columns is-centered is-multiline is-vcentered margin-0">
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileScopeSelect" id="fileScopeSelectAll"
                           value="allRecords"
                           class="fancy-input"
                           v-model="exportData.exportScope"
                           v-on:click.prevent/>
                    <label for="fileScopeSelectAll"
                           class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleScopeType('allRecords')">All Records</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileScopeSelect" id="fileScopeSelectVisible"
                           value="visibleRecords"
                           class="fancy-input"
                           v-model="exportData.exportScope"
                           v-on:click.prevent/>
                    <label for="fileScopeSelectVisible"
                           class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleScopeType('visibleRecords')">Visible Records</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <slot name="fileType"></slot>
          <div class="columns is-centered is-multiline is-vcentered margin-0">
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileTypeSelect" id="fileTypeSelectPdf"
                           value="fileTypePdf"
                           class="fancy-input"
                           v-model="exportData.fileType"
                           v-on:click.prevent/>
                    <label for="fileTypeSelectPdf" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleFileType('pdf')">PDF</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileTypeSelect" id="fileTypeSelectCsv"
                           value="fileTypeCsv"
                           class="fancy-input"
                           v-model="exportData.fileType"
                           v-on:click.prevent/>
                    <label for="fileTypeSelectCsv" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleFileType('csv')">CSV</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='safePartnerForm'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="partnerDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Partner Information</div>
                  </div>
                  <div class="column is-full">
                    <table class="pure-table full-width-table borderless-table">
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th" colspan="2">Partner Name</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td" colspan="2">
                          <div class="field">
                            <p class="control is-expanded has-icons-left">
                              <input class="input input-no-top-margin" type="text"
                                     placeholder="Partner Name"
                                     v-bind:class="{'error-input':v$.partnerDetails.name.$errors.length>0}"
                                     v-model="partnerDetails.name">
                              <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'square-h']"/>
                        </span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th nopadding-th sole-th">Short Name</th>
                        <th class="centered-th nopadding-th sole-th">Location</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td">
                          <div class="field">
                            <p class="control is-expanded has-icons-left">
                              <input class="input input-no-top-margin" type="text"
                                     placeholder="Short Name"
                                     v-bind:class="{'error-input':v$.partnerDetails.shortname.$errors.length>0}"
                                     v-model="partnerDetails.shortname">
                              <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'face-smile-wink']"/>
                        </span>
                            </p>
                          </div>
                        </td>

                        <td class="starting-td nopadding-td">
                          <div class="field">
                            <p class="control is-expanded has-icons-left">


                              <select v-model="partnerDetails.location"
                                      v-bind:class="{'error-input':v$.partnerDetails.location.$errors.length>0}"
                                      class="input input-no-top-margin">
                                <option disabled value="">Select One</option>
                                <option v-for="(locationAvailable, index) in locationsAvailable"
                                        v-bind:value="locationAvailable.countryid" v-bind:key="index">{{
                                    locationAvailable.country_name
                                  }}
                                </option>

                              </select>


                              <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'earth-africa']"/>
                        </span>
                            </p>
                          </div>
                        </td>


                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th nopadding-th sole-th" colspan="2">Partner Email</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td" colspan="2">
                          <div class="field">
                            <p class="control is-expanded has-icons-left">
                              <input class="input input-no-top-margin" type="text"
                                     placeholder="Partner Email"
                                     v-bind:class="{'error-input':v$.partnerDetails.email.$errors.length>0}"
                                     v-model="partnerDetails.email">
                              <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'at']"/>
                        </span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th nopadding-th sole-th" colspan="2">Partner Description</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td" colspan="2">
                          <div class="field">
                            <p class="control is-expanded">
                                  <textarea class="textarea" placeholder="Partner Description"
                                            ref="partnerDescription"
                                            id="partnerDescription"
                                            v-on:keyup="resizeById('partnerDescription')"
                                            v-model="partnerDetails.description"
                                  ></textarea>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='tableImports'">
          <table class="pure-table full-width-table borderless-table">
            <tbody>
            <tr>
              <td class="nopadding-td sole-td">
                <slot name="cautionText"></slot>
              </td>
            </tr>
            </tbody>
            <thead>
            <tr>
              <th class="centered-th nopadding-th sole-th">Updated File</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="ending-td nopadding-td sole-td bottom-td">
                <div class="field">
                  <p class="control is-expanded">
                    <dropZone2Component
                        v-bind:id="`preapprovalFile`"
                        v-bind:key="`preapprovalFile`"
                        v-bind:fileIdentifier="`preapprovalFile`"
                        v-bind:formName="`preapprovalFileAttachment`"
                        v-bind:zoneTitle="'Pre-approval File'"
                        v-bind:imageDataObj="imports.file"
                        v-bind:acceptedFiles="'text/csv'"
                        v-on:dropZone2Emissions="dropZone2Emissions"
                        v-on:uploadInProgress="uploadInProgress"
                    ></dropZone2Component>
                  </p>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-if="formFor==='manageUserProfile'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="userDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">User</div>
                  </div>

                  <div class="column is-full">
                    <table class="pure-table full-width-table borderless-table">
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th">Name</th>
                        <th class="centered-th middle-th nopadding-th end-half-th">Email</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="no-bottomborder-td right-border-td nopadding-td start-half-td">
                          {{ userIdentificationData.userNames }}
                        </td>
                        <td class="no-bottomborder-td nopadding-td">{{ userIdentificationData.userEmail }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="userDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Role</div>
                  </div>

                  <div class="columns is-centered is-multiline is-vcentered margin-0">
                    <div class="column is-narrow">
                      <div class="field is-narrow">
                        <div class="control">
                          <div class="fancy-input-group padded-checkboxes">
                            <input type="radio" name="userProfileRoleSelect" id="userProfileRoleRep"
                                   value="Representative"
                                   class="fancy-input"
                                   v-model="userProfileData.role"
                                   v-on:click.prevent/>
                            <label for="userProfileRoleRep"
                                   class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                                   v-on:click.stop="selectUserRole('Representative')">Representative</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-narrow">
                      <div class="field is-narrow">
                        <div class="control">
                          <div class="fancy-input-group padded-checkboxes">
                            <input type="radio" name="userProfileRoleSelect" id="userProfileRoleCoord"
                                   value="Coordinator"
                                   class="fancy-input"
                                   v-model="userProfileData.role"
                                   v-on:click.prevent/>
                            <label for="userProfileRoleCoord"
                                   class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                                   v-on:click.stop="selectUserRole('Coordinator')">Coordinator</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="userDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Partner Selection</div>
                  </div>
                  <div class="column is-full" v-if="userProfileData.role==='' || userProfileData.role===null">
                    Please select a role to continue.
                  </div>
                  <div class="columns is-centered is-multiline is-vcentered margin-0" v-else>
                    <div class="column is-full" v-for="(partner, index) in activePartners"
                         v-bind:key="index">
                      <div class="field is-narrow">
                        <div class="control">
                          <div class="fancy-input-group">

                            <input v-bind:type="partnerSelectType" name="partnerSelect"
                                   v-bind:id="`partner_${partner.id}`"
                                   value="selected"
                                   class="fancy-input"
                                   v-model="userProfileData.partner[partner.id]"
                                   v-on:click.prevent v-if="partnerSelectType==='radio'"/>

                            <input v-bind:type="partnerSelectType"
                                   v-bind:id="`partner_${partner.id}`"
                                   value="true"
                                   class="fancy-input"
                                   v-model="userProfileData.partner[partner.id]"
                                   v-on:click.prevent v-if="partnerSelectType==='checkbox'"/>

                            <label v-bind:for="`partner_${partner.id}`"
                                   class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                                   v-on:click.stop="selectPartnerPermitted(partner.id)">{{ partner.name }}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>

        </div>

        <div v-if="formFor==='attachingPartnerInvoice'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Case</div>
                  </div>

                  <div class="column is-full">
                    <table class="pure-table full-width-table borderless-table">
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th" colspan="2">Patient Name</th>
                        <th class="centered-th middle-th nopadding-th" colspan="2">Case ID</th>
                        <th class="centered-th nopadding-th" colspan="2">SAFE Ask (USD)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td" colspan="2">{{ decodeURIComponent(invoiceTableData.p_name) }}</td>
                        <td class="middle-td nopadding-td" colspan="2">{{ invoiceTableData.caseid }}</td>
                        <td class="ending-td nopadding-td" colspan="2">{{
                            invoiceTableData.f_approvalsafeaskamount
                          }}
                        </td>
                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th" colspan="3">Surgery</th>
                        <th class="centered-th nopadding-th" colspan="3">Date</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td bottom-td" colspan="3">{{
                            invoiceTableData.f_approvalsurgeryperformed
                          }}
                        </td>
                        <td class="ending-td nopadding-td bottom-td" colspan="3">{{
                            invoiceTableData.surgeryperformancedate
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="invoiceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Invoice</div>
                  </div>


                  <div class="column is-full">
                    <table class="pure-table full-width-table borderless-table">
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th">Invoice Number</th>
                        <th class="centered-th nopadding-th">Invoice Date</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td">
                          <div class="field">
                            <p class="control is-expanded has-icons-left">
                              <input class="input input-no-top-margin" type="text"
                                     placeholder="Invoice Number"
                                     v-bind:class="{'error-input':v$.invoice.number.$errors.length>0}"
                                     v-model="invoice.number">
                              <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'circle-question']"/>
                        </span>
                            </p>
                          </div>
                        </td>
                        <td class="ending-td nopadding-td">
                          <div class="field">
                            <p class="control is-expanded has-icons-left">
                              <datepicker v-model="invoice.date" name="invoiceDate"
                                          v-bind:disabled-dates="invoiceDateConstrain"
                                          v-bind:clear-button="true"
                                          v-bind:input-class="'input-custom'"
                                          v-bind:wrapper-class="setDatePickerClassInvoiceDate"
                                          v-bind:calendar-class="'calendar-custom'"
                                          v-on:selected="invoiceDateSelected">
                              </datepicker>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th nopadding-th sole-th" colspan="2">Invoice Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="ending-td nopadding-td sole-td" colspan="2">
                          <div class="field has-addons">
                            <p class="control">
                        <span class="select">
                          <select v-model="invoice.currency"
                                  v-bind:class="{'error-input':v$.invoice.currency.$errors.length>0}">
                            <option value="">Select One</option>
                            <option value="USD">USD</option>
                            <option value="KES">KES</option>
                            <option value="UGX">UGX</option>
                            <option value="TSH">TSH</option>
                            <option value="ETB">ETB</option>
                            <option value="MWK">MWK</option>
                            <option value="BIF">BIF</option>
                          </select>
                        </span>
                            </p>
                            <p class="control is-expanded">
                              <input class="input input-no-margin-top" type="number"
                                     placeholder="Invoice Amount"
                                     v-bind:class="{'error-input':v$.invoice.amount.$errors.length>0}"
                                     v-model.number="invoice.amount"
                                     v-on:keydown="decimalNumbersAllowed">
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th nopadding-th sole-th" colspan="2">Invoice File</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="ending-td nopadding-td sole-td bottom-td" colspan="2">
                          <div class="field">
                            <p class="control is-expanded">
                              <dropZone2Component
                                  v-bind:id="`partnerInvoiceFile`"
                                  v-bind:key="`partnerInvoiceFile`"
                                  v-bind:fileIdentifier="`partnerInvoiceFile`"
                                  v-bind:formName="`partnerInvoiceAttachment`"
                                  v-bind:zoneTitle="'Invoice File'"
                                  v-bind:dataTs="returnDataTsAndPartnerId(invoiceTableData.caseid, invoiceTableData.recordyear)"
                                  v-bind:imageDataObj="invoice.file"
                                  v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                                  v-on:dropZone2Emissions="dropZone2Emissions"
                                  v-on:uploadInProgress="uploadInProgress"
                              ></dropZone2Component>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='changingSurgeryPerformed'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Case</div>
                  </div>

                  <div class="column is-full">
                    <table class="pure-table full-width-table borderless-table">
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th">Patient Name</th>
                        <th class="centered-th nopadding-th">Case ID</th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td">{{ surgeryTableData.p_name }}</td>
                        <td class="ending-td nopadding-td">{{ surgeryTableData.caseid }}</td>
                      </tr>
                      </tbody>
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th">Surgery</th>
                        <th class="centered-th nopadding-th">SAFE Ask (USD)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td bottom-td">{{
                            surgeryTableData.f_approvalsurgeryperformed
                          }}
                        </td>
                        <td class="nopadding-td" colspan="2">{{ surgeryTableData.f_approvalsafeaskamount }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="invoiceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Surgery Change</div>
                  </div>

                  <div class="column is-full">
                    <div class="columns is-multiline is-mobile is-vcentered">
                      <div class="column is-half">
                        <label class="label has-text-centered">Surgery Performed</label>
                        <div class="field">
                          <p class="control">
                        <span class="select is-fullwidth">
                          <select v-model="surgeryChange.surgeryPerformed"
                                  v-bind:class="{'error-input':v$.surgeryChange.surgeryPerformed.$errors.length>0}">
                            <option disabled value="">Select One</option>
                            <option v-for="(surgeryAvailable, index) in surgeriesReturned"
                                    v-bind:value="surgeryAvailable.surgery" v-bind:key="index">{{
                                surgeryAvailable.surgery
                              }}</option>
                          </select>
                        </span>
                          </p>
                        </div>
                      </div>
                      <div class="column is-half">
                        <label class="label has-text-centered">Safe Ask</label>
                        <div class="safe-ask-amount">{{ surgeryChange.safeAskAmount }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingAmhInvoice'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">AMH Invoice</div>
                  </div>
                  <div class="column is-5 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Number</label>
                    {{ invoiceTableData.invoicenumber }}
                  </div>
                  <div class="column is-3 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Amount</label>
                    {{ invoiceTableData.invoiceAmount }}
                  </div>
                  <div class="column is-4 has-text-left bottom-border-input">
                    <label class="label has-text-centered">Pocket</label>
                    {{ invoiceTableData.invoicePocket }}
                  </div>
                  <div class="column is-full">
                    <label class="label has-text-centered">Case IDs</label>
                    <div class="caseid-container">
                      <a v-for="(caseId) in returnArrayFromCSV(invoiceTableData.caseIdList)" v-bind:key="caseId"
                         class="button is-success is-light caseid-button"
                         v-bind:href="'/caseview/'+caseId+'/financecase/'+invoiceTableData.partnerid+'/'+invoiceTableData.recordyear"
                         target="_blank"><span>{{ caseId }}</span>
                        <span class="icon is-small">
                      <i class="fas fa-arrow-up-right-from-square"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="invoiceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full has-text-left">
                    <label class="label has-text-centered">Signed Invoice File</label>
                    <div class="field">
                      <p class="control is-expanded"
                         v-bind:class="{'error-input':v$.signedInvoice.file.$errors.length>0}">
                        <dropZone2Component
                            v-bind:id="`signedAmhInvoiceFile`"
                            v-bind:key="`signedAmhInvoiceFile`"
                            v-bind:fileIdentifier="`signedAmhInvoiceFile`"
                            v-bind:formName="`signedAmhInvoiceAttachment`"
                            v-bind:zoneTitle="'Signed Invoice File'"
                            v-bind:dataTs="returnDataInvoiceAndPartnerId(invoiceTableData.invoicenumber, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="signedInvoice.file"
                            v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png,.application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingRemittance'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">AMH Invoice</div>
                  </div>
                  <div class="column is-5 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Number</label>
                    {{ invoiceTableData.invoicenumber }}
                  </div>
                  <div class="column is-3 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Amount</label>
                    {{ invoiceTableData.invoiceAmount }}
                  </div>
                  <div class="column is-4 has-text-left bottom-border-input">
                    <label class="label has-text-centered">Pocket</label>
                    {{ invoiceTableData.invoicePocket }}
                  </div>
                  <div class="column is-full">
                    <label class="label has-text-centered">Case IDs</label>
                    <div class="caseid-container">
                      <a v-for="(caseId) in returnArrayFromCSV(invoiceTableData.caseIdList)" v-bind:key="caseId"
                         class="button is-success is-light caseid-button"
                         v-bind:href="'/caseview/'+caseId+'/financecase/'+invoiceTableData.partnerid+'/'+invoiceTableData.recordyear"
                         target="_blank"><span>{{ caseId }}</span>
                        <span class="icon is-small">
                      <i class="fas fa-arrow-up-right-from-square"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="remitanceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Remittance Advice</div>
                  </div>

                  <div class="column is-half has-text-left right-border-input bottom-border-input">
                    <label class="label has-text-centered">Remittance Reference</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-top-margin" type="text"
                               placeholder="Reference"
                               v-bind:class="{'error-input':v$.remittanceAdvice.ref.$errors.length>0}"
                               v-model="remittanceAdvice.ref">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'circle-question']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="column is-half has-text-left bottom-border-input">
                    <label class="label has-text-centered">Remitance Date</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <datepicker v-model="remittanceAdvice.date" name="remittanceDate"
                                    v-bind:disabled-dates="invoiceDateConstrain"
                                    v-bind:clear-button="true"
                                    v-bind:input-class="'input-custom'"
                                    v-bind:wrapper-class="setDatePickerClassRemitanceDate"
                                    v-bind:calendar-class="'calendar-custom'"
                                    v-on:selected="remittanceDateSelected">
                        </datepicker>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">Remitted Amount</label>
                    <div class="field has-addons">
                      <p class="control">
                        <span class="select">
                          <select v-model="remittanceAdvice.currency"
                                  v-bind:class="{'error-input':v$.remittanceAdvice.currency.$errors.length>0}">
                            <option value="">Select One</option>
                            <option value="USD">USD</option>
                            <option value="KES">KES</option>
                            <option value="UGX">UGX</option>
                            <option value="TSH">TSH</option>
                            <option value="ETB">ETB</option>
                            <option value="MWK">MWK</option>
                            <option value="BIF">BIF</option>
                          </select>
                        </span>
                      </p>
                      <p class="control is-expanded">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="Remittance Amount"
                               v-bind:class="{'error-input':v$.remittanceAdvice.amount.$errors.length>0}"
                               v-model.number="remittanceAdvice.amount"
                               v-on:keydown="decimalNumbersAllowed">
                      </p>
                    </div>
                  </div>


                  <div class="column is-full has-text-left">
                    <div class="field">
                      <p class="control is-expanded"
                         v-bind:class="{'error-input':v$.remittanceAdvice.file.$errors.length>0}">
                        <dropZone2Component
                            v-bind:id="`amhRemittanceFile`"
                            v-bind:key="`amhRemittanceFile`"
                            v-bind:fileIdentifier="`amhRemittanceFile`"
                            v-bind:formName="`amhRemittanceAttachment`"
                            v-bind:zoneTitle="'Remittance Advice'"
                            v-bind:dataTs="returnDataInvoiceAndPartnerId(invoiceTableData.invoicenumber, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="remittanceAdvice.file"
                            v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingReceipt'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">AMH Remittance</div>
                  </div>
                  <div class="column is-5 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Reference</label>
                    {{ invoiceTableData.remittanceRef }}
                  </div>
                  <div class="column is-3 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Amount</label>
                    {{ invoiceTableData.remittanceAmount }}
                  </div>
                  <div class="column is-4 has-text-left bottom-border-input">
                    <label class="label has-text-centered">Pocket</label>
                    {{ invoiceTableData.invoicePocket }}
                  </div>
                  <div class="column is-full">
                    <label class="label has-text-centered">Case IDs</label>
                    <div class="caseid-container">
                      <a v-for="(caseId) in returnArrayFromCSV(invoiceTableData.caseIdList)" v-bind:key="caseId"
                         class="button is-success is-light caseid-button"
                         v-bind:href="'/caseview/'+caseId+'/financecase/'+invoiceTableData.partnerid+'/'+invoiceTableData.recordyear"
                         target="_blank"><span>{{ caseId }}</span>
                        <span class="icon is-small">
                      <i class="fas fa-arrow-up-right-from-square"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="remitanceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Receipt</div>
                  </div>

                  <div class="column is-half has-text-left right-border-input bottom-border-input">
                    <label class="label has-text-centered">Receipt Number</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-top-margin" type="text"
                               placeholder="Reference"
                               v-bind:class="{'error-input':v$.receipt.number.$errors.length>0}"
                               v-model="receipt.number">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'circle-question']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="column is-half has-text-left bottom-border-input">
                    <label class="label has-text-centered">Receipt Date</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <datepicker v-model="receipt.date" name="remittanceDate"
                                    v-bind:disabled-dates="invoiceDateConstrain"
                                    v-bind:clear-button="true"
                                    v-bind:input-class="'input-custom'"
                                    v-bind:wrapper-class="setDatePickerClassReceiptDate"
                                    v-bind:calendar-class="'calendar-custom'"
                                    v-on:selected="remittanceDateSelected">
                        </datepicker>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">Receipt Amount</label>
                    <div class="field has-addons">
                      <p class="control">
                        <span class="select">
                          <select v-model="receipt.currency"
                                  v-bind:class="{'error-input':v$.receipt.currency.$errors.length>0}">
                            <option value="">Select One</option>
                            <option value="USD">USD</option>
                            <option value="KES">KES</option>
                            <option value="UGX">UGX</option>
                            <option value="TSH">TSH</option>
                            <option value="ETB">ETB</option>
                            <option value="MWK">MWK</option>
                            <option value="BIF">BIF</option>
                          </select>
                        </span>
                      </p>
                      <p class="control is-expanded">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="Receipt Amount"
                               v-bind:class="{'error-input':v$.receipt.amount.$errors.length>0}"
                               v-model.number="receipt.amount"
                               v-on:keydown="decimalNumbersAllowed">
                      </p>
                    </div>
                  </div>


                  <div class="column is-full has-text-left">
                    <div class="field">
                      <p class="control is-expanded"
                         v-bind:class="{'error-input':v$.receipt.file.$errors.length>0}">
                        <dropZone2Component
                            v-bind:id="`partnerReceiptFile`"
                            v-bind:key="`partnerReceiptFile`"
                            v-bind:fileIdentifier="`partnerReceiptFile`"
                            v-bind:formName="`partnerReceiptAttachment`"
                            v-bind:zoneTitle="'Receipt Document'"
                            v-bind:dataTs="returnDataInvoiceAndPartnerId(invoiceTableData.remittanceRef, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="receipt.file"
                            v-bind:acceptedFiles="'application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="remitanceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Other Information</div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">USD Exchange Rate</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="USD Rate"
                               v-bind:class="{'error-input':v$.receipt.usdrate.$errors.length>0}"
                               v-model.number="receipt.usdrate"
                               v-on:keydown="decimalNumbersAllowed">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'dollar-sign']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div v-if="formFor==='updatingFundsAllocation'">

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Details</div>
                  </div>

                  <div class="column is-full">
                    <table class="pure-table full-width-table borderless-table">
                      <thead>
                      <tr>
                        <th class="centered-th starting-th nopadding-th" style="width: 40%;">Partner</th>
                        <th class="centered-th middle-th nopadding-th" style="width: 20%;">Pocket</th>
                        <th class="centered-th nopadding-th" style="width: 40%;">Current Limit (USD)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="starting-td nopadding-td bottom-td">{{ fundsUpdatingData.partnername }}</td>
                        <td class="middle-td nopadding-td bottom-td">{{ fundsUpdatingData.fundfocus }}</td>
                        <td class="ending-td nopadding-td bottom-td">{{ fundsUpdatingData.currentlimit }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="newFundsDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Fund Update</div>
                  </div>

                  <div class="column is-full has-text-left">
                    <label class="label has-text-centered">Fund Limit</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-margin-top" type="number"
                               v-bind:placeholder="`New ${fundsUpdatingData.fundfocus} Limit`"
                               v-bind:class="{'error-input':v$.fund.limit.$errors.length>0}"
                               v-model.number="fund.limit"
                               v-on:keydown="decimalNumbersAllowed">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'dollar-sign']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>

      </section>
      <footer class="modal-card-foot">

        <div v-if="formFor==='tableExports'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="processExport">Export</button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingPartnerInvoice'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="savePartnerInvoiceData"
                          v-bind:disabled="!invoiceSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingAmhInvoice'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveSignedAmhInvoiceData"
                          v-bind:disabled="!signedInvoiceSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingRemittance'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveAmhRemittanceData"
                          v-bind:disabled="!remittanceSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingReceipt'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveReceiptData"
                          v-bind:disabled="!receiptSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='manageUserProfile'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveUserProfile"
                          v-bind:disabled="!saveUserProfileActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='safePartnerForm'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveSafePartner"
                          v-bind:disabled="!saveSafePartnerActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='updatingFundsAllocation'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveNewLimitData"
                          v-bind:disabled="!fundLimitSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='changingSurgeryPerformed'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveNewSurgeryPerformed"
                          v-bind:disabled="!surgeryChangeSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </VueFinalModal>
</template>


<style>
.z-index-1 {
  z-index: 1 !important;
}

.margin-0 {
  margin: 0 !important;
}

.width-100 {
  width: 100% !important;
}

.confirm-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-modal-content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
}

.confirm-modal-content > * + * {
  margin: 0.5rem 0;
}

.confirm-modal-content h1 {
  font-size: 1.375rem;
}

.confirm-modal-content button {
  margin: 0.25rem 0 0 auto;
  padding: 0 8px;
  border: 1px solid;
  border-radius: 0.5rem;
}

.dark .confirm-modal-content {
  background: #000;
}

.margin-50-up-down {
  margin: 50px 0 !important;
}

.caseid-button {
  margin: 3px !important;
}

.caseid-container {
  max-height: 300px;
  width: 100%;
  overflow: auto;
}

.full-width-table {
  width: 100% !important;
}

.borderless-table {
  border: none !important;
}

.centered-th {
  text-align: center !important;
  background-color: white !important;
}

.nopadding-th {
  padding-bottom: 0 !important;
}

.nopadding-td {
  padding-top: 0 !important;
}

.starting-th {
  border-top: none !important;
  border-left: none !important;
}

.starting-th,
.middle-th,
.starting-td,
.middle-td {
  border-right: 1px solid black !important;
}

.starting-td {
  border-left: none !important;
}

.starting-td,
.middle-td,
.ending-td {
  border-bottom: 1px solid black !important;
  vertical-align: middle !important;
  text-align: left !important;
}

.no-bottomborder-td {
  border-bottom: none !important;
  vertical-align: middle !important;
  text-align: left !important;
}

.start-half-td {
  border-left: none !important;
}

.end-half-th {
  border-right: none !important;
}

.right-border-td {
  border-right: 1px solid black !important;
}

.bottom-td {
  border-bottom: none !important;
}

.sole-th {
  border: none !important;
}

.sole-td {
  border-left: none !important;
  border-right: none !important;
}

.cautiontext {
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: red;
}

</style>